export const occupancyRoute = (lotId = ':lotId') => `/lot/${lotId}/spots`
